import { Canvas } from '@react-three/fiber'
import { Preload } from '@react-three/drei'
import { Background } from './components/Background'
import { Title } from './components/Title'
import { Lens } from './components/Lens'

export default function App() {
    return (
        <Canvas camera={{ position: [0, 0, 20], fov: 15 }}>
            <Lens></Lens>
            <Preload />
            {/*<Environment files="https://dl.polyhaven.org/file/ph-assets/HDRIs/hdr/1k/thatch_chapel_1k.hdr" />*/}
        </Canvas>
    )
}
